import React, { Component } from 'react';

class NotFound extends Component {
	render() {
		return (
			<div className='page center'>
				<h2 className='red'>Not Found</h2>
			</div>
		);
	}
}

export default NotFound;
